// LE-00 (promo): リッチメニュー A / B の物理ボタン配置（別リポ kawai-line-richmenu の
// createRichMenus.ts の areas/bounds と一致させる）。
//
// リッチメニュータップ分析（RichmenuTapAnalytics）を「実際のボタン配置と同じ並び」で
// カード表示するための構造定義。item キーは promo_events.payload.item と一致し、
// 表示ラベルは segment.ts の RICHMENU_ITEM_LABELS を使う。
//
// 配置（両タブ共通 / size 2500x1686 の本体 5 分割）:
//   上段: 左ワイド(1625w) + 右(875w)      → 6 列グリッドで span 4 / 2
//   下段: 3 等分(833/833/834)             → span 2 / 2 / 2

/** 1 ボタン分のセル（item と 6 列グリッド上の占有幅）。 */
export interface RichmenuCell {
  /** promo_events.payload.item と一致するキー。 */
  item: string;
  /** 6 列グリッド上の占有列数（上段左=4 / それ以外=2）。 */
  span: number;
}

/** 1 タブ分のレイアウト。 */
export interface RichmenuTabLayout {
  tab: 'A' | 'B';
  label: string;
  /** 上段→下段の順。各 row の span 合計は 6（= 1 行）。 */
  rows: RichmenuCell[][];
}

/** リッチメニュー A / B の配置（createRichMenus.ts 準拠）。 */
export const RICHMENU_LAYOUT: readonly RichmenuTabLayout[] = [
  {
    tab: 'A',
    label: 'リッチメニューA',
    rows: [
      [
        { item: 'inspection', span: 4 },
        { item: 'fuel_discount', span: 2 },
      ],
      [
        { item: 'reservation', span: 2 },
        { item: 'route', span: 2 },
        { item: 'fuel_price', span: 2 },
      ],
    ],
  },
  {
    tab: 'B',
    label: 'リッチメニューB',
    rows: [
      [
        { item: 'washfree_about', span: 4 },
        { item: 'wash_reservation', span: 2 },
      ],
      [
        { item: 'atwash', span: 2 },
        { item: 'washfree_top', span: 2 },
        { item: 'keeper', span: 2 },
      ],
    ],
  },
];

/** レイアウトに含まれる全 item キー（「その他」判定用）。 */
export const RICHMENU_LAYOUT_ITEMS: ReadonlySet<string> = new Set(
  RICHMENU_LAYOUT.flatMap((t) => t.rows.flat().map((c) => c.item)),
);
